import * as React from 'react'
import { useState, useContext } from 'react'

import SortableSelect, { arrayMove, SortableMultiValue } from '../../sortable_select/SortableSelect'
import CommonContext from '../../CommonContext'

interface DepartmentWorktypesProps {
  department: {
    id: number
    name: string
    worktypes?: Array<{
      id: number
      title: string
    }>
  }
}

export default function DepartmentWorktypes({ department }: DepartmentWorktypesProps) {
  const dictionaries = useContext(CommonContext)
  const { availableWorktypes } = dictionaries
  const worktypeOptions = availableWorktypes.map(w => {
    return { label: w.title, value: w.id }
  })
  const initialWorktypeIds = department.worktypes ? department.worktypes.map(w => w.id) : []
  const [selectedWorktypeIds, setSelectedWorktypeIds] = useState(initialWorktypeIds)

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const newValue = arrayMove(selectedWorktypeIds, oldIndex, newIndex)
    setSelectedWorktypeIds(newValue)
  }

  return (
    <div className="mt-4">
      <h4>{department.name}</h4>
      <SortableSelect
        axis="xy"
        onSortEnd={onSortEnd}
        distance={4}
        getHelperDimensions={({ node }) => node.getBoundingClientRect()}
        isMulti
        placeholder="Vælg eller skriv..."
        value={selectedWorktypeIds.map(worktypeId => worktypeOptions.find(u => u.value === worktypeId))}
        onChange={(opts: any) => setSelectedWorktypeIds(opts === null ? [] : opts.map(o => o.value))}
        options={worktypeOptions}
        components={{
          MultiValue: SortableMultiValue,
        }}
        closeMenuOnSelect={false}
      />
      {selectedWorktypeIds.map(worktypeId => {
        return <input key={worktypeId} type="hidden" name={`department_worktypes[${department.id}][worktype_ids][]`} value={worktypeId} />
      })}
    </div>
  )
}
